/* Twinz Shop — global.js */
(function () {
  'use strict';
  var TWINZ = window.TWINZ || { currency: 'EGP', moneyFormat: '{{amount}} EGP' };

  /* Mirrors Shopify's Liquid `money` filter formatting rules so JS-rendered
     prices (cart drawer, variant swap) match server-rendered prices exactly. */
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = isNaN(precision) ? 2 : precision;
    thousands = thousands === undefined ? ',' : thousands;
    decimal = decimal === undefined ? '.' : decimal;
    var negative = number < 0 ? '-' : '';
    var n = Math.abs(number).toFixed(precision);
    var parts = n.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';
    return negative + dollars + cents;
  }
  function money(cents) {
    cents = cents || 0;
    var format = (TWINZ && TWINZ.moneyFormat) || '{{amount}} EGP';
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholder);
    if (!match) return formatWithDelimiters(cents / 100, 2) + ' EGP';
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents / 100, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents / 100, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents / 100, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents / 100, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents / 100, 2);
    }
    return format.replace(placeholder, value);
  }

  /* ---------- Drawers (menu / search / cart) ---------- */
  function openDrawer(sel) {
    var d = document.querySelector(sel);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var f = d.querySelector('input, button, a');
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeDrawers() {
    document.querySelectorAll('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    });
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__overlay')) { closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;
    var wrap = btn.closest('[data-qty]');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val += btn.hasAttribute('data-qty-plus') ? 1 : -1;
    if (val < 1) val = 1;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product gallery ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var main = gal.querySelector('[data-gallery-main] img');
    gal.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-img');
        if (main && src) main.src = src;
        gal.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- Variant selection ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variants = [];
    try {
      var vEl = form.querySelector('[data-variants]');
      variants = JSON.parse((vEl ? vEl.textContent : form.getAttribute('data-variants')) || '[]');
    } catch (err) { variants = []; }
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var atc = form.querySelector('[data-atc]');

    function selectedOptions() {
      var opts = [];
      form.querySelectorAll('[data-option-index]').forEach(function (group) {
        var active = group.querySelector('[data-value].is-active');
        opts[parseInt(group.getAttribute('data-option-index'), 10)] = active ? active.getAttribute('data-value') : null;
      });
      return opts;
    }
    function match(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function update() {
      var v = match(selectedOptions());
      if (!v) return;
      if (idInput) idInput.value = v.id;
      var mainImg = document.querySelector('[data-gallery-main] img');

if (mainImg && v.featured_media) {
    mainImg.src = v.featured_media;
}
      if (priceEl) {
        var html = '<span class="price__regular">' + money(v.price) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html = '<span class="price__sale">' + money(v.price) + '</span> <s class="price__compare">' + money(v.compare_at_price) + '</s>';
        }
        priceEl.innerHTML = html;
      }
      if (atc) {
        if (v.available) { atc.removeAttribute('disabled'); atc.querySelector('span') && (atc.querySelector('span').textContent = atc.getAttribute('data-add-label')); }
        else { atc.setAttribute('disabled', ''); atc.querySelector('span') && (atc.querySelector('span').textContent = atc.getAttribute('data-sold-label')); }
      }
    }
    form.querySelectorAll('[data-option-index] [data-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-unavailable')) return;
        var group = btn.closest('[data-option-index]');
        group.querySelectorAll('[data-value]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var lbl = group.querySelector('[data-option-selected]');
        if (lbl) lbl.textContent = btn.getAttribute('data-value');
        update();
      });
    });
  });

  /* ---------- Cart helpers ---------- */
  function refreshCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count; el.hidden = cart.item_count === 0;
      });
    });
  }
  function renderCartDrawer() {
    var body = document.querySelector('[data-cart-body]');
    var foot = document.querySelector('[data-cart-foot]');
    if (!body) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (cart.item_count === 0) {
        body.innerHTML = '<div class="cart-empty"><p>' + (body.getAttribute('data-empty') || 'Your bag is empty.') + '</p><a class="btn" href="/collections/all">' + (body.getAttribute('data-shop') || 'Shop now') + '</a></div>';
        if (foot) foot.innerHTML = '';
        return;
      }
      var html = '';
      cart.items.forEach(function (it) {
        html += '<div class="cart-line" data-key="' + it.key + '">' +
          '<a class="cart-line__media" href="' + it.url + '">' + (it.image ? '<img src="' + it.image + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="cart-line__details"><a class="cart-line__title" href="' + it.url + '">' + it.product_title + '</a>' +
          (it.variant_title ? '<span class="cart-line__variant">' + it.variant_title + '</span>' : '') +
          '<button type="button" class="cart-line__remove" data-cart-remove="' + it.key + '">' + (body.getAttribute('data-remove') || 'Remove') + '</button></div>' +
          '<div class="cart-line__qty"><div class="qty" data-qty><button type="button" data-qty-minus data-cart-qty="' + it.key + '" data-dir="-1">&minus;</button>' +
          '<input type="text" value="' + it.quantity + '" readonly><button type="button" data-qty-plus data-cart-qty="' + it.key + '" data-dir="1">+</button></div>' +
          '<span class="cart-line__total">' + money(it.final_line_price) + '</span></div></div>';
      });
      body.innerHTML = html;
      if (foot) {
        foot.innerHTML = '<div class="cart-foot__row"><span>' + (foot.getAttribute('data-subtotal') || 'Subtotal') + '</span><span>' + money(cart.total_price) + '</span></div>' +
          '<p class="cart-foot__note">' + (foot.getAttribute('data-note') || '') + '</p>' +
          '<a class="btn btn--block" href="/checkout">' + (foot.getAttribute('data-checkout') || 'Checkout') + '</a>' +
          '<a class="btn btn--light btn--block" href="/cart">' + (foot.getAttribute('data-viewcart') || 'View cart') + '</a>';
      }
    });
  }
  function addToCart(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) { return r.json(); }).then(function () {
      refreshCount(); renderCartDrawer();
      if (!window.TWINZ || window.TWINZ.cartType !== 'page') openDrawer('#CartDrawer');
      else window.location.href = '/cart';
    });
  }
  function changeCart(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function () { refreshCount(); renderCartDrawer(); });
  }

  /* product form submit */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = form.querySelector('[name="id"]').value;
      var q = form.querySelector('[name="quantity"]');
      addToCart(id, q ? parseInt(q.value, 10) : 1);
    });
  });
  /* quick add */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest('[data-quick-add]');
    if (!qa) return;
    e.preventDefault();
    addToCart(qa.getAttribute('data-quick-add'), 1);
  });
  /* cart drawer remove + qty */
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) { changeCart(rm.getAttribute('data-cart-remove'), 0); return; }
    var cq = e.target.closest('[data-cart-qty]');
    if (cq) {
      var line = cq.closest('.cart-line');
      var input = line.querySelector('input');
      var val = (parseInt(input.value, 10) || 1) + parseInt(cq.getAttribute('data-dir'), 10);
      if (val < 0) val = 0;
      changeCart(cq.getAttribute('data-cart-qty'), val);
    }
  });
  document.querySelectorAll('[data-drawer-open="#CartDrawer"]').forEach(function (b) {
    b.addEventListener('click', renderCartDrawer);
  });
  if (document.querySelector('[data-cart-body]')) renderCartDrawer();

  /* ---------- Carousel rails ---------- */
  document.querySelectorAll('.rail-wrap').forEach(function (wrap) {
    var rail = wrap.querySelector('.product-rail, .carousel__track');
    var bar = wrap.querySelector('.rail-progress__bar');
    if (!rail) return;
    function upd() {
      if (!bar) return;
      var max = rail.scrollWidth - rail.clientWidth;
      var pct = max > 0 ? (Math.abs(rail.scrollLeft) / max) * 100 : 0;
      bar.style.width = Math.max(12, pct) + '%';
    }
    rail.addEventListener('scroll', upd); upd();
    wrap.querySelectorAll('[data-rail-prev]').forEach(function (b) { b.addEventListener('click', function () { rail.scrollBy({ left: -rail.clientWidth * 0.8, behavior: 'smooth' }); }); });
    wrap.querySelectorAll('[data-rail-next]').forEach(function (b) { b.addEventListener('click', function () { rail.scrollBy({ left: rail.clientWidth * 0.8, behavior: 'smooth' }); }); });
  });

  /* ---------- Accordions ---------- */
  document.querySelectorAll('[data-accordion-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('[data-accordion]');
      if (!item) return;
      var panel = item.querySelector('[data-accordion-panel]');
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) panel.hidden = !open;
    });
  });

  /* ---------- Reviews tab scroll ---------- */
  document.querySelectorAll('[data-scroll-to]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      var t = document.querySelector(b.getAttribute('data-scroll-to'));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); }
    });
  });

  /* ---------- Predictive search ---------- */
  var psForm = document.querySelector('[data-predictive-search]');
  if (psForm) {
    var input = psForm.querySelector('[data-predictive-input]');
    var results = psForm.querySelector('[data-predictive-results]');
    var t = null;
    input && input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(t);
      if (q.length < 2) { if (results) results.innerHTML = ''; return; }
      t = setTimeout(function () {
        fetch('/search/suggest?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product,collection,article,page&resources[limit]=6')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('[data-predictive]');
            if (results) results.innerHTML = inner ? inner.innerHTML : '';
          }).catch(function () {});
      }, 220);
    });
  }

  /* ---------- Facets: auto submit on sort/filter change ---------- */
  document.querySelectorAll('[data-facets-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () { var f = sel.closest('form'); if (f) f.submit(); });
  });

  /* ---------- Address delete ---------- */
  document.querySelectorAll('[data-address-delete]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!confirm(btn.getAttribute('data-confirm') || 'Delete this address?')) return;
      var url = btn.getAttribute('data-address-delete');
      var f = document.createElement('form');
      f.method = 'post'; f.action = url;
      f.innerHTML = '<input type="hidden" name="_method" value="delete">';
      document.body.appendChild(f); f.submit();
    });
  });

  /* ---------- Hero slideshow ---------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var slides = [].slice.call(root.querySelectorAll('[data-slide]'));
    var dots = [].slice.call(root.querySelectorAll('[data-slide-dot]'));
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var interval = parseInt(root.getAttribute('data-interval') || '5000', 10);
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function start() { stop(); if (interval > 0) timer = setInterval(function () { show(i + 1); }, interval); }
    function stop() { if (timer) clearInterval(timer); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); start(); }); });
    root.querySelectorAll('[data-slide-prev]').forEach(function (b) { b.addEventListener('click', function () { show(i - 1); start(); }); });
    root.querySelectorAll('[data-slide-next]').forEach(function (b) { b.addEventListener('click', function () { show(i + 1); start(); }); });
    show(0); start();
  });
})();
